import { render, staticRenderFns } from "./RatioImage.vue?vue&type=template&id=29548cf7&scoped=true&"
import script from "./RatioImage.vue?vue&type=script&lang=js&"
export * from "./RatioImage.vue?vue&type=script&lang=js&"
import style0 from "./RatioImage.vue?vue&type=style&index=0&id=29548cf7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29548cf7",
  null
  
)

export default component.exports